<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M19 11h-1.7c0-.74-.16-1.44-.43-2.07l1.23-1.23-1.41-1.41-2.2 2.2c-.52-.28-1.09-.45-1.69-.49V5h-2v1.11c-.61.14-1.16.39-1.64.72L4.41 3.86 3 5.27 10.73 13H8v2h2.73l6.87 6.87 1.41-1.41-3.65-3.66c.36-.5.64-1.07.8-1.69H19v-2zm-9 1.08V11h2.08l-2.08-2.08V12.08zM4.41 22.36 22.36 4.41 20.95 3 3 20.95l1.41 1.41z"
    fill="currentColor"
  />
</svg>
